import {
  Component,
  ChangeDetectionStrategy,
  signal,
  input,
  output,
  booleanAttribute,
  computed
} from '@angular/core';
import { Addon } from '@zerops/models/billing';
import {
  ipV4AddonButtonText,
  ProjectStatuses,
  requestIpV4DisabledReason
} from '@zerops/models/project';

type InfoCardColor = 'orange' | 'green' | 'base';

@Component({
  selector: 'zui-ip-info-card',
  templateUrl: './ip-info-card.component.html',
  styleUrl: './ip-info-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IpInfoCardComponent {

  ipV4 = input<string>();
  sharedIpV4 = input<string>();
  ipV4PendingRequest = input(false);
  ipV4AddonInProcess = input(false);
  ipV6 = input<string>();
  requestIpv4Key = input<string>();
  ipV4Addon = input<Addon>();
  projectName = input<string>();
  projectId = input<string>();
  projectStatus = input<ProjectStatuses>();
  clientUnverified = input(false);
  publicZone = input<string>();
  color = input<InfoCardColor>('base');
  showOnlyIpV4Button = input(false, { transform: booleanAttribute });
  showDesc = input(false, { transform: booleanAttribute });
  requestIpV4 = output<void>();
  selectedCard = signal<string>('CNAME');
  requestIpV4DisabledTooltip = computed(() => requestIpV4DisabledReason(this.projectStatus(), this.clientUnverified()));
  requestIpV4Disabled = computed(() => !!this.requestIpV4DisabledTooltip());
  requestIpV4ButtonText = computed(() => ipV4AddonButtonText(this.ipV4Addon()));

}
